export default "__VITE_ASSET__DJo0RazH__"